// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const select: Styleguide["select"] = {
    defaultProps: {
        iconProps: { src: ChevronDown, size: 16 }, // Store Custom Code
        css: css`
            &&:not(.selected)[data-selected-index=""] {
                color: ${getColor("placeholder")};

                &:disabled,
                &.disabled {
                    color: ${getColor("placeholder.disabled")};
                }
            }

            option {
                color: ${getColor("text.input")};
                /* Store Custom Code - Start */
                background-color: ${x => getColor("common.background")};
                /* Store Custom Code - End */

                select:not(.selected) &[value=""] {
                    color: ${getColor("placeholder")};
                }

                &:disabled {
                    background-color: ${x => getColor("common.disabled")};
                    color: ${getColor("text.disabled")};
                }
            }
        `,
    },
};

export default select;
